<template>
  <div class="page-container">
    <header class="navbar">
      <div class="nav-content">
        <div class="company-logo">
          <h1 style="font-size: 1.2rem">广州添添健康信息咨询有限公司</h1>
        </div>
        <nav class="nav-links">
          <router-link to="/" class="nav-item">首页</router-link>
          <router-link to="/about" class="nav-item">关于我们</router-link>
          <router-link to="/business" class="nav-item active">业务板块</router-link>
        </nav>
      </div>
    </header>

    <main class="main-content">
<!--      <section class="hero">-->
<!--        <div class="content-wrapper hero-content">-->
<!--          <h1 class="hero-title">{{ hero.title }}</h1>-->
<!--          <p class="hero-subtitle">{{ hero.subtitle }}</p>-->
<!--        </div>-->
<!--      </section>-->

      <section class="business-details-section">
        <div class="content-wrapper">
          <h2 class="section-title">{{ sections.businessDetails.title }}</h2>
          <div class="business-grid">
            <div v-for="service in sections.businessDetails.services" :key="service.id" class="business-card">
              <div class="card-icon">{{ service.icon }}</div>
              <h3 class="card-title">{{ service.name }}</h3>
              <ul class="service-list">
                <li v-for="item in service.items" :key="item">{{ item }}</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section class="model-section">
        <div class="content-wrapper">
          <h2 class="section-title">{{ sections.commercialModel.title }}</h2>
          <div class="model-details">
            <div class="model-item-detail">
              <h4>{{ sections.commercialModel.model.title }}</h4>
              <p>{{ sections.commercialModel.model.description }}</p>
            </div>
            <div class="model-item-detail">
              <h4>{{ sections.commercialModel.growthStrategy.title }}</h4>
              <p>{{ sections.commercialModel.growthStrategy.description }}</p>
            </div>
          </div>
        </div>
      </section>

      <section class="preference-section">
        <div class="content-wrapper">
          <h2 class="section-title">{{ sections.investmentPreference.title }}</h2>
          <div class="preference-chart-container">
            <div class="chart-column">
              <h4>{{ sections.investmentPreference.willingness.title }}</h4>
              <p>{{ sections.investmentPreference.willingness.description }}</p>
            </div>
            <div class="chart-column">
              <h4>{{ sections.investmentPreference.categories.title }}</h4>
              <ul>
                <li v-for="category in sections.investmentPreference.categories.items" :key="category">{{ category }}</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section class="company-image-section">
        <div class="content-wrapper">
          <h2 class="section-title">合作伙伴</h2>
          <img src="@/assets/cocompany.png" alt="Company Collaboration" style="max-width: 100%; height: auto; display: block; margin: 20px auto;">
        </div>
      </section>
    </main>

    <footer class="footer">
      <div class="content-wrapper">
        <!--        <div class="footer-grid">-->
        <!--          <div class="footer-info">-->
        <!--            <h3>广东添添健康产业集团有限公司</h3>-->
        <!--            <p>致力于打造中国领先的银发经济产业平台</p>-->
        <!--          </div>-->
        <!--          <div class="footer-contact">-->
        <!--            <h4>联系我们</h4>-->
        <!--            <p>电话：020-XXXXXXXX</p>-->
        <!--            <p>邮箱：contact@example.com</p>-->
        <!--            <p>地址：广州市XXX区XXX路XX号</p>-->
        <!--          </div>-->
        <!--        </div>-->
        <div class="footer-bottom">
          <p>© 2024 广州添添健康信息咨询有限公司 版权所有 备案号 <a href="https://beian.miit.gov.cn" target="_blank" style="color: rgba(255, 255, 255, 0.5)">粤ICP备2024303205号</a> </p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Business',
  data() {
    return {
      hero: {
        title: '我们的业务领域',
        subtitle: '探索添添健康如何通过多元化业务组合，引领健康产业新未来。'
      },
      sections: {
        businessDetails: {
          title: '业务板块详情',
          services: [
            {
              id: 'interest_exploration',
              icon: '🎯',
              name: '兴趣探索',
              items: ['游学旅游：主题疗养、文化游学、候鸟式旅居服务']
            },
            {
              id: 'health_management',
              icon: '❤️',
              name: '健康管理',
              items: ['健康管理：健康体检、健康档案、健康咨询、慢病管理、康复护理']
            },
            {
              id: 'elderly_care_services',
              icon: '🏡',
              name: '养老服务',
              items: ['养老服务：机构养老、社区养老、居家养老、智慧养老、养老金融']
            },
            {
              id: 'cultural_entertainment',
              icon: '🎭',
              name: '文娱活动',
              items: ['文娱活动：老年大学、兴趣班、文艺演出、赛事活动']
            },
            {
              id: 'smart_products',
              icon: '📱',
              name: '智能产品',
              items: ['智能产品：智能穿戴、智能家居、健康监测设备、康复辅助器具']
            },
            {
              id: 'supply_chain',
              icon: '🛒',
              name: '供应链服务',
              items: ['供应链服务：集采平台、品牌赋能、营销整合、仓配一体化']
            }
          ]
        },
        commercialModel: {
          title: '商业模式及增长策略',
          model: {
            title: '商业模式',
            description: '公司以“平台+内容+终端+应用”为核心商业模式，构建开放、共享、共赢的产业生态。通过线上线下融合，提供全方位的健康养老产品和服务。'
          },
          growthStrategy: {
            title: '增长策略',
            description: '聚焦核心城市，深耕重点区域，通过内生增长与外延并购相结合的方式，快速扩大市场份额。加强品牌建设，提升服务品质，拓展多元化盈利渠道。'
          }
        },
        investmentPreference: {
          title: '投资偏好',
          willingness: {
            title: '投资意愿',
            description: '我们积极寻求与大健康、养老、科技等领域的优质企业建立战略合作关系，共同推动产业发展。'
          },
          categories: {
            title: '投资类别',
            items: [
              '智慧养老解决方案',
              '康复医疗器械与技术',
              '健康管理与服务平台',
              '创新型养老服务模式',
              '大健康消费品品牌'
            ]
          }
        }
      }
    };
  },
  mounted() {
    // 初始化滚动动画
    this.initAnimations();
    // 监听滚动以触发动画
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    // 清理事件监听
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    initAnimations() {
      // 初始化滚动动画，跳过首屏内容
      const sections = document.querySelectorAll('section:not(.hero)');
      sections.forEach(section => {
        const sectionTop = section.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;
        // 只对首屏以下的内容添加动画类
        if (sectionTop > windowHeight) {
          section.classList.add('scroll-animation');
        }
      });
    },
    handleScroll() {
      // 处理滚动动画
      const sections = document.querySelectorAll('.scroll-animation');
      sections.forEach(section => {
        const sectionTop = section.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;
        if (sectionTop < windowHeight * 0.75) {
          section.classList.add('animate');
        }
      });
    }
  }
};
</script>

<style scoped>
/* 在这里添加或确保已定义以下 CSS 变量 */
:root {
  --primary-color: #4169E1; /* 主题蓝 */
  --primary-light: #6B8FF2;
  --primary-dark: #2850B8;
  --text-primary: #2C3E50;   /* 主要文字颜色 */
  --text-secondary: #526488; /* 次要文字颜色 */
  --card-bg: #ffffff;       /* 卡片背景色 */
  --light-bg: #f8f9ff;      /* 浅色背景 */
}

/* 确保 content-wrapper, section-title 等通用样式与 About.vue 一致或已定义 */
/* 例如: */
.content-wrapper {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-title {
  text-align: center;
  font-size: 2rem;
  margin-bottom: 40px; /* About.vue 中是 40px */
  color: var(--primary-color);
  position: relative;
  padding-bottom: 15px;
  font-weight: 600;
}

.section-title::after {
  content: '';
  position: absolute;
  width: 60px;
  height: 3px;
  background: linear-gradient(to right, var(--primary-color), var(--primary-light));
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}

.business-details-section {
  padding: 60px 0; /* 根据需要调整 */
}

.business-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); /* 响应式列 */
  gap: 30px;
  margin-top: 40px; /* 与 About.vue 的 values-grid 类似 */
}

.business-card {
  background: var(--card-bg);
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center; /* 卡片内容居中，类似 value-card */
  text-align: center;   /* 文本居中 */
}

.business-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
}

.card-icon {
  font-size: 2.5rem; /* 与 About.vue 的 value-icon 类似 */
  margin-bottom: 20px;
  color: var(--primary-color); /* 可以让图标也使用主题色 */
}

.card-title {
  color: var(--primary-color);
  font-size: 1.3rem; /* 与 About.vue 的 value-card h3 类似 */
  margin-bottom: 20px;
  font-weight: 600;
}

.service-list {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
}

.service-list li {
  color: var(--text-secondary);
  margin-bottom: 10px;
  line-height: 1.5; /* 与 About.vue 的 value-content p 类似 */
}

.service-list li:last-child {
  margin-bottom: 0;
}

/* model-section 和 preference-section 的样式可以按需添加 */
.model-section, .preference-section {
  padding: 60px 0;
  background-color: var(--light-bg); /* 可以交替背景色 */
}

.model-details, .preference-chart-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  margin-top: 40px;
}

.model-item-detail, .chart-column {
  background: var(--card-bg);
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.model-item-detail:hover, .chart-column:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
}

.model-item-detail h4, .chart-column h4 {
  color: var(--primary-color);
  font-size: 1.3rem;
  margin-bottom: 15px;
  font-weight: 600;
}

.model-item-detail p, .chart-column p, .chart-column ul {
  color: var(--text-secondary);
  line-height: 1.6;
}

.chart-column ul {
  list-style-position: inside;
  padding-left: 0;
}

.chart-column li {
  margin-bottom: 8px;
}

/* 页脚样式 */
.footer {
  background: linear-gradient(to right, #333333, #444444);
  color: white;
  padding: 50px 0 30px;
}

.footer-grid {
  display: flex;
  justify-content: space-between;
  gap: 40px;
  margin-bottom: 30px;
}

.footer-info h3 {
  font-size: 1.3rem;
  margin-bottom: 15px;
  font-weight: 500;
}

.footer-info p {
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.5;
}

.footer-contact h4 {
  font-size: 1.1rem;
  margin-bottom: 15px;
  font-weight: 500;
}

.footer-contact p {
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 8px;
}

.footer-bottom {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-bottom p {
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.9rem;
}

/* 导航栏样式 */
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: rgba(255, 255, 255, 0.95);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 15px 0;
  backdrop-filter: blur(5px);
}

.nav-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.company-logo h1 {
  font-size: 1.5rem;
  color: var(--primary-color);
  margin: 0;
  font-weight: 600;
}

.nav-links {
  display: flex;
  gap: 30px;
}

.nav-item {
  text-decoration: none;
  color: var(--text-primary);
  font-weight: 500;
  padding: 5px 0;
  position: relative;
  transition: color 0.3s ease;
}

.nav-item:hover,
.nav-item.active {
  color: var(--primary-color);
}

.nav-item::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 0;
  height: 2px;
  background-color: var(--primary-color);
  transition: width 0.3s ease;
}

.nav-item:hover::after,
.nav-item.active::after {
  width: 100%;
}

/* 响应式调整 (可以从 About.vue 借鉴或根据 Business.vue 的具体需求调整) */
@media (max-width: 768px) {
  .business-grid, .model-details, .preference-chart-container {
    grid-template-columns: 1fr; /* 在较小屏幕上单列显示 */
  }
}

</style>